import React from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Rail from './Rail';
import TopBar from './TopBar';
import { tokens } from '../theme/tokens';

const AppShell = () => {
  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', backgroundColor: tokens.colors.bg }}>
      <Rail />
      <Box sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
        <TopBar />
        <Box
          component="main"
          sx={{
            px: { xs: 2, md: 3.75 },
            pt: 3,
            pb: 10,
            maxWidth: 1180,
            width: '100%',
            mx: 'auto',
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default AppShell;